/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { Header, Icon, Segment } from 'semantic-ui-react'
import { HeatMapOpeningTimes } from './HeatMapOpeningTimes/HeatMapOpeningTimes'
import { Insights } from './Insights'
import { useTranslation } from 'react-i18next'
import { RateRadialChart } from '../../Shared/RateRadialChart'
import { getColor } from './openingTimeHelpers'

const OpenTimeSegment = React.memo(({title, openingsTimes, isWeekly, onClose = undefined, colorScale = undefined}) => {
    const [t] = useTranslation()

    return (
      <Segment color={isWeekly ? 'blue' : 'green'}>
          {onClose && <Icon
            name="close"
            css={css`
                position: absolute;
                top: 10px;
                right: 10px;
                cursor: pointer;
                color: #999;
                z-index: 10;

                &:hover {
                    color: #333;
                }
            `}
            onClick={(onClose ? onClose : undefined)}
          />}

          <div
            css={css`
                display: flex;
                justify-content: space-between;
            `}
          >
              <Header>{title}</Header>

          </div>

          <div css={css`
              display: grid;
              grid-template-columns: 1fr 1fr 200px;
              grid-template-areas: 
                "insights insights radialChart";
          `}>
              <Insights
                openings={openingsTimes.openings}
                isWeekly={isWeekly}
                peakTimePeriods={openingsTimes.peakTimePeriods}
                css={css`
                    grid-area: insights;
                    align-self: center;
                `}/>
              <RateRadialChart
                label={t('openings.opening_times.average_opening')}
                rate={openingsTimes.averageOpenRate}
                getColor={getColor}
                css={css`
                    grid-area: radialChart;
                `}
              />
          </div>

          <div css={css`margin-top: -50px;`}>
              <HeatMapOpeningTimes openingTimes={openingsTimes.openings} isWeekly={isWeekly} colorScale={colorScale}/>
          </div>
      </Segment>
    )
})

export { OpenTimeSegment }
